<template>
  <div class="pa-2">
    <div class="mt-4">
      <span class="enter-code-message"
        >{{
          $t('Enter the verification code that was sent to you by ') +
          (sendingMethod === 2 ? $t('SMS') : $t('Email'))
        }}: {{ sendingMethod === 2 ?  firstChars + 'XXXXX' + lastChars : lastChars }}.
        {{ $t('The code is valid for 5 minutes.') }}</span
      >
    </div>
    <div class="d-flex justify-space-between align-center">
      <v-text-field
      @input="$emit('set-sms-confirm-code', $event)"
        @keypress.enter="confirmLogin"
        autofocus
        outlined
        class="pa-0 ma-0 mt-4"
        placeholder=" "
        type="number"
        hide-details
        dense
        maxLength="6"
        style="max-width: 130px"
      ></v-text-field>
      <Button
        class="mt-4"
        :clickAction="confirmLogin"
        :text="$t('Confirm')"
        :loading="loading"
        :disabled="isConfirmButtonDisabled"
        width="120px"
      ></Button>
    </div>
    <v-divider class="my-2"></v-divider>
    <div class="d-flex justify-space-between align-center">
      <small class="light-text f-12" v-if="timerTime > 0">
        {{ $t('You can ask for a new code in') }} {{ timerTime }} {{ $t('seconds') }}
      </small>

      <Button
        v-else
        :clickAction="login"
        :text="$t('Send New Code')"
        :disabled="!!timerTime"
        width="120px"
        btnType="grey"
      >
      </Button>

      <Button
        :clickAction="clear"
        width="150px"
        :text="$t('Back to Login')"
        btnType="grey"
      ></Button>
    </div>
  </div>
</template>

<script>
import Button from '@/components/BaseComponents/Button/Button.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'ConfirmedLogin',
  props: {
    login: Function,
    clear: Function,
    loading: Boolean,
    confirmLogin: Function,
    timerTime: Number,
    isConfirmButtonDisabled: Boolean,
    sendingMethod: Number,
  },
  emits: ['set-sms-confirm-code'],
  components: { Button },
  computed: {
    ...mapGetters(['lastChars', 'firstChars']),
  },
}
</script>
